export const AdminOverrideError = "User is ADMIN OVERRIDE";
